//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import { PRINCIPAL, NAVBARS,COLOR_BOTONES} from '../../constants/colors';

//Contextos
import herramientaContext from '../../context/herramientaContext/herramientaContex';
import './FormHerramienta.css';

function FormHerramienta({data, setData, minimizar, nuevoEditado, handleChangeHerramientas, index, tDocID = '' }){

    const hContext = useContext(herramientaContext);
    const {agregarHerramienta, actualizarHerramientaLista, modificarHerramienta, eliminarHerramienta} = hContext;

    const [herramienta, setHerramienta] = useState({codHerramienta:"",name: ''});

    const [titulo, setTitulo] = useState(nuevoEditado);

    const validacion =  () => {
        const newErrors = {};
        if (herramienta.codHerramienta === '' || herramienta.codHerramienta === undefined) return newErrors.codigo = 'El código de Herramienta debe ser colocado'
        if (herramienta.name === '' || herramienta.name === undefined) return newErrors.nombre = 'El nombre debe ser colocado'
        return '';
    };

    const handlerGenerar = async ()  => {

        const errorAxi = validacion();

        if ( errorAxi === "" ) {

            try {
                const dato = herramienta;
                const res = await agregarHerramienta(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se guardo una nueva Herramienta`,
                        icon: 'success',
                        text: `Código: ${res.codHerramienta} \n Nombre: ${res.name}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarHerramientaLista();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre de la Herramienta",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }

        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }
    }

    const handlerModificar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "") {

            try {
                const dato = {
                    id: data.id,
                    codHerramienta:herramienta.codHerramienta,
                    name: herramienta.name
                }
                await setData(dato);
                const res = await modificarHerramienta(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Se modificó la Herramienta`,
                        icon: 'success',
                        text: `Nombre: ${res.name}\n Código: ${res.codHerramienta}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarHerramientaLista();
                    minimizar();
                    let herramientaToChange = {id:res._id, label:res.name, value:res.codHerramienta, name:res.name};
                    handleChangeHerramientas(herramientaToChange,index);
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre de la Herramienta",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }
    }

    const handlerEliminar = () => {
        Swal.fire({
            title: `Estas seguro que deseas eliminar esta Herramienta?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
                const id = data.id
                const resp = await eliminarHerramienta(id, tDocID);
                if(resp.data.delete){
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `La Herramienta fue borrada correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizarHerramientaLista();
                    handleChangeHerramientas({},index);
                    minimizar(null);
                }else{
                    Swal.fire({
                        title: `Operacion no puede realizarse`,
                        icon: 'error',
                        text: `${resp.data.msg}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                }
            } else if (result.isDismissed) {
                minimizar();
            }
        });
    }

    useEffect(()=>{
        if(data !== undefined){
            let codigoHerramienta = (data.codHerramienta != undefined) ? data.codHerramienta : data.value;
            let herramientaModelado = {id:data?.herramientaID, codHerramienta:codigoHerramienta, name: data?.name};
            setHerramienta(herramientaModelado);
        }
    },[data])

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}}>
                {titulo} Herramienta
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de Herramienta: </div>
                <input disabled={ titulo === "Modificar"} value={herramienta.codHerramienta} className='label-form-group-data' onChange={data => setHerramienta({ ...herramienta, ['codHerramienta']:data.target.value })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={herramienta.name} className='label-form-group-data' onChange={data => setHerramienta({ ...herramienta, ['name']: data.target.value })} />
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button>
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )
                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar()}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormHerramienta;
